import { Component, OnInit, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';
import { Catalogo } from "../../interfaces/general";
import { debounceTime } from "rxjs/operators";
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
	selector: "app-direccion",
	templateUrl: "./direccion.component.html",
	styleUrls: ["./direccion.component.css"],
})
export class DireccionComponent implements OnInit  {
	lat = 21.0181;
	lng = -101.258;
	zoom = 9;
	otraCalle = false;
	Asentamiento: any;

	municipios: any;
	listadoLocalidadesFiltradas: any
	listadoCalles: any
	listadoCiudades:any = []
	tieneCiudad = false
	idEstado;
	listadoAsentamientos: any
	listadoAsentamientosFiltrados: any
	gtoEs: boolean = true
	cps:Array<any> = []

	@Input() tipoAsentamientos: Array<Catalogo>;
	@Input() tipoCarreteras: Array<Catalogo>;
	@Input() tipoCaminos: Array<Catalogo>;
	@Input() Direccion: FormGroup;
	@Input() tipoPersona: number;
	@Input() esSolicitante:boolean = false
	@Input() curp;
	@Input() estados: Array<any> = [];
	@Input() esEdicion = false

	constructor(private serviciosGenerales: ServiciosGeneralesService,
		private snackBar: MatSnackBar) {}

	ngOnInit(): void {
		this.cambioEstado()
		this.cambioMunicipio()
		this.obtenerCP();
		this.obtenerLocalidad();
		this.obtenerCalle();
		this.escucharCurp();

		this.Direccion.get('Direcciones_EntidadFederativaID').disable()
		this.Direccion.get('Direcciones_MunicipioID').disable()
		if(this.Direccion.get('Direcciones_EntidadFederativaID').value !== "" ||
			this.Direccion.get('Direcciones_EntidadFederativaID').value !== null) {
				this.listarMunicipios(+this.Direccion.get('Direcciones_EntidadFederativaID').value)
				if(this.Direccion.get('Direcciones_CiudadID').value !== null ) {
					this.obtenerCiudades(this.Direccion.get('Direcciones_MunicipioID').value)

				} else {

				}
		} else {

		}
		console.log('valor de ciudad' + this.Direccion.get('Direcciones_CiudadID').value )
		console.log(this.Direccion.get('Direcciones_CalleID').value)
		if(this.Direccion.get('Direcciones_CalleID').value === 0 ) {
			console.log('init')
			this.Direccion.setValue({id:0, Nombre:'Deseo agregar una calle nueva'})
		}
		if(this.Direccion.get('Direcciones_CiudadID').value !== null) {
			this.obtenerCiudades(this.Direccion.get('Direcciones_MunicipioID').value)
		}

		// this.Direccion.get('Direcciones_CiudadID').disable()
		// this.Direccion.get('Direcciones_AsentamientoID').disable()
		// this.lat = this.Direccion.get('Direcciones_Latitud').value
		// this.lng = this.Direccion.get('Direcciones_Longitud').value
	}

	ListadoAsentamientos (idMunicipio:number) {
		console.log(typeof idMunicipio)
		if(idMunicipio !== 0 || idMunicipio !== null || idMunicipio !== undefined) {
			this.serviciosGenerales.listadoColonias(idMunicipio).subscribe(res => {
				this.listadoAsentamientos = res
				this.listadoAsentamientosFiltrados = []
				if(this.cps.length > 0) {
					this.cps.forEach(colonia => {
						this.listadoAsentamientosFiltrados.push(
							...this.listadoAsentamientos.filter(res => colonia.Asentamiento_ID === res.ID)
						)
					});
				} else {
					this.listadoAsentamientosFiltrados = this.listadoAsentamientos
				}

				this.Direccion.get('Direcciones_AsentamientoID').enable
			})
		}

	}

	ngOnChanges(changes) {

		// this.Direccion.get('Direcciones_EntidadFederativaID').setValue(1012)
		this.listarMunicipios(+this.Direccion.get('Direcciones_EntidadFederativaID').value)

		if (this.Direccion.controls.Direcciones_EntidadFederativaID.value !== '') {
			const valor:string =  this.Direccion.get('Direcciones_CalleID').value
			if(valor !== "" || typeof valor !== null  ) {
				//Consulta para poner el objeto
				if(this.Direccion.get('Direcciones_CalleID').value === 0 ) {
					this.Direccion.setValue({id:0, Nombre:'Deseo agregar una calle nueva'})
				} else {
					this.serviciosGenerales.VerCalleID(valor).subscribe(res => {
						this.Direccion.get('Direcciones_CalleID').setValue(res[0])
					})
				}

			}
			if(this.Direccion.get('Direcciones_LocalidadID').value != "" || this.Direccion.get('Direcciones_LocalidadID').value != null) {
				//Consulta para poner el objeto
				this.serviciosGenerales.verLocalidad(this.Direccion.get('Direcciones_LocalidadID').value).subscribe(res => {
					this.Direccion.get('Direcciones_LocalidadID').setValue(res[0])
				})
			}

		}
		// if(this.Direccion.get('Direcciones_CodigoPostal').value != '') {
		// 	//console.log(this.Direccion.get('Direcciones_CodigoPostal'))
		// 	this.obtenerDatosCodigoPostal(+this.Direccion.get('Direcciones_CodigoPostal'))
		// }
		this.Direccion.get('Direcciones_EntidadFederativaID').disable()
		this.Direccion.get('Direcciones_MunicipioID').disable()
		if(this.Direccion.get('Direcciones_CiudadID').value !== null) {
			this.obtenerCiudades(this.Direccion.get('Direcciones_MunicipioID').value)
		}

	}

	cambioMunicipio() {
		this.Direccion.get("Direcciones_MunicipioID")
			.valueChanges.pipe(debounceTime(1500))
			.subscribe((res) =>{
				this.ListadoAsentamientos(res)
			}
		);
	}

	cambioEstado() {
		this.Direccion.get("Direcciones_EntidadFederativaID")
			.valueChanges.pipe(debounceTime(1500))
			.subscribe((res) =>{
				this.listarMunicipios(res)
			}
		);
	}

	revisarCampo(campo) {
		if (typeof(this.Direccion.controls[campo].value) !== 'object') {
			this.Direccion.controls[campo].setValue(null);
			this.openSnackBar('Debe de selecionar al menos una opcion','Entendido')
		}
	}

	obtenerCP(): void {
		this.Direccion.get("Direcciones_CodigoPostal")
			 .valueChanges.pipe(debounceTime(1500))
			.subscribe((codigoPostal) =>{
				if(codigoPostal != null) {
					this.Direccion.get('Direcciones_AsentamientoID').disable()
					this.Direccion.get('Direcciones_AsentamientoID').setValue(0)
					codigoPostal.toString().length === 5
					? this.obtenerDatosCodigoPostal(codigoPostal)
					: ""
				}
				else {
					this.openSnackBar('El codigo postal no contiene direcciones o no es valido','Entendido')
				}
			}
		);
	}


	listarMunicipios(idEstado: number) {
		this.serviciosGenerales.listadoMunicipios(idEstado).subscribe((res) => {
			this.municipios = res;
			if(this.Direccion.get('Direcciones_MunicipioID').value === null) {
				this.ListadoAsentamientos(this.municipios.ID)
				this
			} else {
				this.ListadoAsentamientos(+this.Direccion.get('Direcciones_MunicipioID').value)
			}
		});
	}

	obtenerCiudades(Municipio_ID) {
		this.serviciosGenerales.verCiudad(Municipio_ID).subscribe(res => {
			this.tieneCiudad = true
			this.listadoCiudades = res
			this.Direccion.get('Direcciones_CiudadID').setValue(res[0].ID)
		})
	}

	obtenerLocalidad () {
		this.Direccion.get("Direcciones_LocalidadID")
			.valueChanges
			.subscribe((localidad : string) =>{
				console.log(localidad)
				this.filtrar(localidad)
			});
	}
	obtenerCalle () {
		this.Direccion.get("Direcciones_CalleID")
			.valueChanges
			.subscribe((calle : any) =>{
				console.log(calle)
				// if(calle.id) {
				// 	if (calle.id === 0) {
				// 		this.otraCalle = true
				// 	}
				// }
				if(calle !== null) {

					this.filtrar(calle,false)

				}
			});
	}

	filtrar (valor:string , bandera = true) {
		console.log(valor)
		const municipio = 	this.Direccion.get('Direcciones_MunicipioID').value
		if(valor !== null) {
			if (valor.length >=4) {
				if (bandera) {
					this.serviciosGenerales.listadoLocalidades(+municipio , valor).subscribe(res => {
						this.listadoLocalidadesFiltradas = res
					})
				} else {
					console.log('filtrar calles')
					this.serviciosGenerales.listadoCalles(+municipio , valor).subscribe(res => {
						console.log(res)
						this.listadoCalles = res
						this.listadoCalles.push({id:0, Nombre:'Deseo agregar una calle nueva'})
					})

				}
			}
		}




	}
	centerChange(e) {
		if(this.esEdicion) {
			this.Direccion.get('Direcciones_Latitud').setValue(e.coords.lat)
			this.Direccion.get('Direcciones_Longitud').setValue(e.coords.lng)
		}
	}

	obtenerDatosCodigoPostal(codigoPostal: number) {
		this.serviciosGenerales
			.obtenerDatosCodigoPostal(+codigoPostal)
			.subscribe((res) => {
				this.Direccion.get('Direcciones_EntidadFederativaID').setValue(res[0].EntFed_ID)
				this.Direccion.get('Direcciones_MunicipioID').setValue(res[0].Municipio_ID)
				this.listadoCiudades = []
				if(this.Direccion.get('Direcciones_EntidadFederativaID').value !== 1012) {
					this.gtoEs = false
				} else {
					this.gtoEs = true
				}
				this.cps = res
				this.Direccion.get('Direcciones_AsentamientoID').enable()
				console.log(res[0].Ciudad_ID)
				if(res[0].Ciudad_ID !== null) {
					this.obtenerCiudades(res[0].Municipio_ID)
					this.Direccion.get('Direcciones_CiudadID').setValue(null)
					this.Direccion.get('Direcciones_LocalidadID').setValue(null)
					this.listadoLocalidadesFiltradas = []

				}else {
					this.Direccion.get('Direcciones_CiudadID').setValue(null)
					this.Direccion.get('Direcciones_LocalidadID').setValue(null)
					this.listadoCiudades = []
					this.listadoLocalidadesFiltradas = []

				}
			});
	}

	displayLocalidad (value) {
		if(value === null) {
			return ''
		}else {
			return typeof value === 'object' ? value.Nombre : value
		}

	}

	buscarLocalidadID(idLocalidad) {

	}

	verID(event) {
		console.log(event.option.value.id)
		this.otraCalle = false
		if(event.option.value.id === 0) {
			this.otraCalle = true
		}
	}

	displayCalles (value) {
		console.log(value)
		if(value === null) {
			return ''
		}else {

			if(value.id === 0) {
				this.otraCalle = true
			}

			return typeof value === 'object' ? value.Nombre : value

		}
	}

	obtenerLocalidades(localidad: number) {
		this.serviciosGenerales.listadoLocalidades(localidad, '').subscribe((res) => {
			this.listadoLocalidadesFiltradas  = res
		})
	}
	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
		duration: 2000,
		});
	}

	escucharCurp(){
		this.curp.valueChanges.pipe(debounceTime(1500))
		.subscribe(CURP => {
			this.Direccion.reset('',{emitEvent:false,onlySelf:true});
		})
	}

}
